/*
import {
  _hm,
  _hmDTM,
  _ht,
  cr,
  a,
  gs,
  useCfmz,
  useLdrz,
  BoxC,
  BtnC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import { useLdrz } from "./_csLdr";
import { useCfmz } from "./_csMdlCfm";
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';

import * as icm from './icm';

import * as IccvCtt from './icvI1z___TzCtt';

export const N = (pz: {
  sPz: _ht.dz,
  cz: {
    i1zz: _ht.dz,
    i10rs: _ht.ls,
    i17rs: _ht.ls,
    _601s: _ht.ls,
  }
}) => {

  const _gUserz = gs.useUserz();
  const _gStgz = gs.useStgz();
  const _sCfmz = useCfmz();
  const _sLdrz = useLdrz();

  const _ccl = () => {
    _sCfmz.show({
      pfx: 'キャンセルして良いですか？',
      onPrs: async (_n: _ht.n) => {
        if (_n == 1) {
          icm.saveI1zzCclAsync1({
            role: 'd',
            ctt: pz.sPz.crt.ctt,
            i1zz: pz.cz.i1zz,
            i10rs: pz.cz.i10rs,
            i17rs: pz.cz.i17rs,
            i15rs: [_gUserz.crt.i15rz],
            i18rz: _gUserz.crt.i18rz,
            hdys: pz.cz._601s,
            _31r_fst: pz.sPz.crt._31rz._fst,
            atrAsync: () => {
              pz.sPz.set({
                steps: [0, 0],
                phs: 'dpy',
              });
            },
            sCfmz: _sCfmz,
            sLdrz: _sLdrz,
          });

        }
      }
    })
  };

  const _drc = _hmDTM.getDrcDay(_hmDTM.getTdy(), pz.cz.i1zz.i1zrz.i1zrd3100s);

  //hf.l(`icvI1zD10Co4 59: ${$drc}, ${_gStgz.crt.S06010212}`)
  return (

    cr.c(BoxC.N, {
      key: -10,
      abtType: 'baseAreaz',
      oClds: [

        cr.c(BoxC.N, {
          key: -10,
          abtType: 'mainAreaz',
          boxStlz: a(`sc/${pz.sPz.crt.dffz.clr}1 pt/4`),
          oClds: [

            cr.c(IccvCtt.N, {
              key: -10,
              sPz: pz.sPz,
              cz: {
                i1zz: pz.cz.i1zz,
                clr: pz.sPz.crt.dffz.clr,
              },
              boxStlz: a('mb/4'),
            }),

            cr.c(BtnC.N, {
              key: -30,
              boxStlz: a('mb/2'),
              abtType: 'fcyz',
              lblCz: {
                textz: {
                  pfx: '利用時間帯・料金・定員\n・各室詳細等の確認',
                  stlz: a(`ta/c`),
                },
              },
              pslPtyz: {
                onPress: () => {
                  cr.openUrl({
//                    url: _gUserz.crt.i191z.i191a1100s
                    url: pz.sPz.crt.i191z.i191a1100s
                  });
                },
              },
            }),

          ]
        }),

        cr.c(BoxC.N, {
          key: -30,
          abtType: 'btnAreaz',
          oClds: [

            cr.c(BtnC.N, {
              key: -10,
              abtType: 'backCmnz',
              boxStlz: a('dh/10 mb/2'),
              lblCz: {
                textz: {
                  pfx: `前の画面に戻る`,
                },
              },
              pslPtyz: {
                onPress: () => {
                  pz.sPz.set({
                    steps: [0, 0],
                    phs: 'dpy',
                  });
                },
              },
            }),

            (pz.sPz.crt.ctt == 'r' && _drc < Number(_gStgz.crt.S06010212)) ||
            (pz.sPz.crt.ctt == 'r' && _hm.i(pz.cz.i1zz.i1zrz.i1zrs1100i, [90])) ||
            (pz.sPz.crt.ctt == 'e' && _hm.i(pz.cz.i1zz.i1zrz.i1zrs1200i, [80, 90])) ?
            undefined
            : 
            cr.c(BtnC.N, {
              key: -20,
              abtType: 'nextCmnz',
              boxStlz: a('dh/10 mb/2'),
              lblCz: {
                textz: {
                  pfx: `この${pz.sPz.crt.dffz.tgt}をキャンセル`,
                },
              },
              pslPtyz: {
                onPress: _ccl,
              },
            })

          ],
        })

      ]
    })
  );
};
